// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "phleboacademy.firebaseapp.com",
  "projectId": "phleboacademy",
  "storageBucket": "phleboacademy.appspot.com",
  "messagingSenderId": "85864873164",
  "appId": "1:85864873164:web:287d542a1545de3ae21669",
  "measurementId": "G-7QJWRM50P2",
  "apiKey": "AIzaSyA_t6gy3Vz_xloORMBt94NtKE4rA0FCJk0"
};
